import { cn } from '@/shared/lib/cn';
import { safeDisplay } from '../utils/trialHelpers';

interface TrialTruncatedTextProps {
  value: string | null | undefined;
  fallback: string;
  className?: string;
  monospace?: boolean;
  nowrap?: boolean;
  maxWidthClass?: string;
}

export function TrialTruncatedText({
  value,
  fallback,
  className,
  monospace = false,
  nowrap = false,
  maxWidthClass = 'max-w-[14rem]',
}: TrialTruncatedTextProps) {
  const display = safeDisplay(value);

  if (!display) {
    return (
      <span className={cn('text-sm text-muted-foreground italic', className)}>{fallback}</span>
    );
  }

  return (
    <span
      className={cn(
        'block text-sm text-foreground min-w-0',
        maxWidthClass,
        nowrap ? 'whitespace-nowrap' : 'truncate',
        monospace && 'font-mono text-xs',
        className,
      )}
      title={display}
    >
      {display}
    </span>
  );
}
